export default __webpack_public_path__ + "static/media/wearable.a8467966.svg";